export default {
    props:{
        id: {},
        label: {default: 'Text field label'},
        name:  {default: ''},
        value: {default: ''},
        mandatory: {default: false},
        consent: {default: false},
        displayValue: {default: ''},
        isFloat: {default: false},
        isCentered: {default: false},
        isActive: {default: false},
        size: {default: 'md'},
    },

    computed: {
        getSizeClass() {
            return 'form-control-' + this.size;
        },

        isLabelFloatActive(){
            if(!AppHelper.empty(this.value) && this.value.length > 0){
                return true;
            }

            return false;
        },

        getValidators(){
            var validators = {}

            if(this.mandatory){
                validators['required'] = true
            }

            switch(this.type){
                case 'email':
                    validators['email'] = true
                    break
                case 'integer':
                    validators['digits'] = true
                    break
                case 'currency':
                case 'double':
                    validators['decimal'] = true
                    break
                case 'url':
                    validators['url'] = true
                    break
                case 'phone':
                    validators['regex'] = /^(\(?\+?[0-9]*\)?)?[0-9_\- \(\)]*$/
            }

            return validators
        }
    },

    inject: ['$validator'],
}


// WEBPACK FOOTER //
// ./src/components/mixins/FormElementMixin.js